module.exports = __webpack_public_path__ + "static/media/cinamon-honey.e50f79b3.jpg";